(function () {
  if (window.__v2ShareInit) return;
  window.__v2ShareInit = 1;

  function isPhone() {
    return !!(window.matchMedia && window.matchMedia('(pointer: coarse)').matches && window.innerWidth < 1025);
  }

  // keep the shopper's chosen variant in the link when there is one
  function productUrl(btn) {
    var base = btn.getAttribute('data-url') || location.href.split('#')[0];
    var m = location.search.match(/[?&]variant=(\d+)/);
    return m ? base.split('?')[0] + '?variant=' + m[1] : base.split('?')[0];
  }

  function copy(btn) {
    var url = productUrl(btn);
    if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(url).catch(function () {});
    btn.setAttribute('title', 'Link copied');
  }

  function shareEmail(btn, url) {
    var nl = '\n';
    var body = (btn.getAttribute('data-body') || '').replace(/\\n/g, nl) + nl + nl + btn.getAttribute('data-title') + nl + url;
    location.href = 'mailto:?subject=' + encodeURIComponent(btn.getAttribute('data-subject') || btn.getAttribute('data-title')) +
      '&body=' + encodeURIComponent(body);
  }

  async function sharePhone(btn, url) {
    var text = (btn.getAttribute('data-text') || '') + ' ' + btn.getAttribute('data-title');
    if (navigator.share) {
      // link only: Messages turns the link into a single preview card with the product photo,
      // so no image file is attached (that produced a second picture)
      try { await navigator.share({ title: btn.getAttribute('data-title'), text: text.trim(), url: url }); } catch (e) {}
      return;
    }
    location.href = 'sms:?&body=' + encodeURIComponent(text.trim() + ' ' + url);
  }

  document.addEventListener('click', async function (e) {
    var btn = e.target.closest && e.target.closest('[data-v2-share]');
    if (!btn) return;
    e.preventDefault();
    var url = productUrl(btn);
    btn.setAttribute('aria-busy', 'true');
    try {
      if (isPhone()) await sharePhone(btn, url);
      else shareEmail(btn, url);
    } finally {
      btn.removeAttribute('aria-busy');
    }
  });
})();
